import { makeStyles } from '@material-ui/core/styles';
import { SecondaryColors, TextColors } from '@/utils/constants';

const useStyles = makeStyles(
  () => ({
    root: {},
    links: {
      width: '100%',
      paddingLeft: 8,
    },
    link: {
      '$root &.MuiLink-root': {
        color: TextColors.dark,
        fontWeight: 'normal',
        display: 'block',
        padding: '5px 0',

        '&:hover': {
          color: SecondaryColors.dark,
        },
      },
    },
    filters: {
      width: '100%',
      '& .filter-checkbox': {
        flex: '0 0 100%',
        width: '100%',
      },
    },
  }),
  { name: 'GenMarketplaceSidebar' },
);

export default useStyles;
